import React, { Fragment, useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  FormGroup
} from "reactstrap";
import FieldWrapper from "../commons/FieldWrapper";
import { saveDefaultQuestion } from "./Axios";

const DefaultQuestionForm = ({
                               bgColor,
                               buttonText,
                               showNotification,
                               addQuestion,
                               question,
                               updateHit,
                               size
                             }) => {
  const [modal, setModal] = useState(false);
  const [questionText, setQuestionText] = useState("");
  const [answerType, setAnswerType] = useState("text");
  const [options, setOptions] = useState([]);
  const [newOption, setNewOption] = useState("");
  const [errors, setErrors] = useState({ question: [], options: [] });

  useEffect(() => {
    if (question) {
      setQuestionText(question.question);
      setAnswerType(question.answer_type || "text");
      setOptions(question.options || []);
    } else {
      setQuestionText("");
      setAnswerType("text");
      setOptions([]);
    }
    setNewOption("");
    setErrors({ question: [], options: [] });
  }, [question, modal]);

  const toggle = () => setModal(!modal);

  const saveErrors = (errs) => {
    setErrors({
      question: errs.question || [],
      options: errs.options || [],
    });
  };

  const addOption = () => {
    if (newOption.trim() !== "" && !options.includes(newOption.trim())) {
      setOptions([...options, newOption.trim()]);
      setNewOption("");
    }
  };

  const removeOption = idx => {
    setOptions(options.filter((_, i) => i !== idx));
  };

  const editOption = (idx, value) => {
    const updated = [...options];
    updated[idx] = value;
    setOptions(updated);
  };

  const handleSubmitQuestion = () => {
    const formData = new FormData();
    formData.append("default_question[question]", questionText);
    formData.append("default_question[answer_type]", answerType);
    if (["single_choice", "multiple_choice"].includes(answerType)) {
      formData.append("default_question[options]", JSON.stringify(options));
    } else {
      formData.append("default_question[options]", JSON.stringify([]));
    }

    saveDefaultQuestion(question, formData, (response) => {
      if (response.status === 201) {
        showNotification("Genial", "Pregunta guardada con éxito!", "success");
        toggle();
        setQuestionText("");
        setAnswerType("text");
        setOptions([]);
        setErrors({ question: [], options: [] });
        addQuestion(response.data);
      } else if (response.status === 200) {
        showNotification("Genial", "Pregunta actualizada con éxito!", "success");
        toggle();
        updateHit(response.data);
      } else if (response.status === 422) {
        saveErrors(response.data);
        showNotification("Ops", "Hubo un error, revisa el formulario!", "danger");
      }
    });
  };

  return (
    <Fragment>
      <Button color={bgColor} onClick={toggle} size={size} style={{ color: "white" }}>
        {buttonText}
      </Button>
      <Modal isOpen={modal} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>
          {buttonText} Pregunta por Defecto
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for="question" className="input_required">Pregunta</Label>
            <FieldWrapper errors={errors.question}>
              <Input
                id="question"
                type="text"
                placeholder="Escribe la pregunta aquí"
                onChange={(e) => setQuestionText(e.target.value)}
                value={questionText}
              />
            </FieldWrapper>
          </FormGroup>

          <FormGroup>
            <Label for="answerType" className="input_required">Tipo de Respuesta</Label>
            <Input
              id="answerType"
              type="select"
              value={answerType}
              onChange={(e) => setAnswerType(e.target.value)}
            >
              <option value="text">Texto</option>
              <option value="number">Número</option>
              <option value="boolean">Sí / No</option>
              <option value="single_choice">Selección única</option>
              <option value="multiple_choice">Selección múltiple</option>
            </Input>
          </FormGroup>

          {["single_choice", "multiple_choice"].includes(answerType) && (
            <FormGroup>
              <Label>Opciones</Label>
              <div className="mb-2 d-flex flex-wrap align-items-center">
                <Input
                  type="text"
                  placeholder="Nueva opción"
                  value={newOption}
                  style={{ maxWidth: 250 }}
                  onChange={e => setNewOption(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && addOption()}
                />
                <Button color="primary" size="sm" className="ms-2" onClick={addOption}>
                  Agregar
                </Button>
              </div>
              <ul className="list-unstyled">
                {options.map((opt, idx) => (
                  <li key={idx} className="d-flex align-items-center mb-1">
                    <Input
                      type="text"
                      value={opt}
                      onChange={e => editOption(idx, e.target.value)}
                      style={{ width: "70%", marginRight: 8 }}
                    />
                    <Button
                      color="danger"
                      size="sm"
                      onClick={() => removeOption(idx)}
                      title="Eliminar opción"
                    >
                      <i className="fas fa-trash"></i>
                    </Button>
                  </li>
                ))}
              </ul>
              {errors.options && errors.options.length > 0 && (
                <div className="text-danger small mt-1">
                  {errors.options.map((err, idx) => (
                    <div key={idx}>{err}</div>
                  ))}
                </div>
              )}
            </FormGroup>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={handleSubmitQuestion}>Guardar</Button>
          <Button color="danger" onClick={toggle}>Cancelar</Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

export default DefaultQuestionForm;
